export class ItemRequest{
    itemId:number;
    unitId?:number;
    saleOrderId?:number;
    constructor(itemId:number,unitId?:number,saleOrderId?:number){
        this.itemId = itemId;
        this.unitId = unitId;
        this.saleOrderId = saleOrderId
    }
}